export enum IconThemeEnum {
  DEFAULT,
  DEFAULT_INNER,
  SUCCESS,
  SUCCESS_INNER,
  ERROR,
  ERROR_INNER,
  WARNING,
  WARNING_INNER,
}

export const IconThemeLabel: Record<IconThemeEnum, string> = {
  [IconThemeEnum.DEFAULT]: "default",
  [IconThemeEnum.DEFAULT_INNER]: "default-inner",
  [IconThemeEnum.SUCCESS]: "success",
  [IconThemeEnum.SUCCESS_INNER]: "success-inner",
  [IconThemeEnum.ERROR]: "error",
  [IconThemeEnum.ERROR_INNER]: "error-inner",
  [IconThemeEnum.WARNING]: "warning",
  [IconThemeEnum.WARNING_INNER]: "warning-inner",
}
